<script setup lang="ts">
import type { ProductExtra } from "@/schemas/product-extra";

defineProps<{ product: ProductExtra }>();
const { onAddToCart, isDisabled, icon } = useAddToCart();
const quantity = ref(1);
</script>

<template>
  <div class="flex flex-col items-center gap-4">
    <div class="text-xl font-medium">
      Sélectionner la quantité
    </div>
    <InputQuantity v-model="quantity" :max="product.stock_quantity" :disabled="isDisabled" />
    <button class="btn-orange" :disabled="isDisabled" @click="onAddToCart({ product_id: product.product_id, quantity })">
      {{ product.pre_order ? "Précommander" : "Ajouter au panier" }}
      <span v-if="icon" class="size-6" :class="icon" />
    </button>
  </div>
</template>
